<div ngbDropdown *ngIf="grupper$ | async as grupper">
    <button class="btn btn-primary btn-sm btn--menu ms-2" id="groupSelect" ngbDropdownToggle>Gruppe: {{selectedGruppe || 'Alle'}}</button>
    <div ngbDropdownMenu aria-labelledby="groupSelect">
        <button (click)="onSelectGruppe(null)" class="dropdown-item">Alle</button>
        <button *ngFor="let gruppe of grupper" (click)="onSelectGruppe(gruppe)" class="dropdown-item">{{gruppe.gruppe}}</button>
    </div>
</div>
